import { render, staticRenderFns } from "./PurchaseHistoryByGoods.vue?vue&type=template&id=78da5aa0"
import script from "./PurchaseHistoryByGoods.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryByGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports